import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Button from '../Button';

import './styles.css';

class Search extends Component {
  constructor(props) {
    super(props);

    this.state = {
      inputValue: '',
    };
  }

    _onInputChange = (e) => {
      this.setState({ inputValue: e.target.value });
    }

    _onSearch = (e) => {
      e.preventDefault();
      this.props.onSearch(this.state.inputValue);
    }

    render() {
      const { className, placeholder } = this.props;

      return (
        <form className={`Search${className ? ` ${className}` : ''}`} onSubmit={this._onSearch}>
          <input
            className="Search__input"
            type="text"
            value={this.state.inputValue}
            onChange={this._onInputChange}
            placeholder={placeholder || 'Buscar'}
          />
          <Button
            className="Search__button"
            skin="primary"
            icon="search"
          />
        </form>
      );
    }
}

Search.propTypes = {
  placeholder: PropTypes.string,
  onSearch: PropTypes.func.isRequired,
};


export default Search;
